import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { useAnchoredPosition as r } from "../hooks/useAnchoredPosition.js";
import { s as p } from "../../../chunks/hyperlink-popover.module.js";
import { jsx as m } from "react/jsx-runtime";

var f = function f(_ref) {
  var t = _ref.anchor,
      i = _ref.containerRef,
      s = _ref.zIndex,
      e = _ref.children;
  var o = "positioned-popover-content",
      n = r({
    anchor: t,
    floatingElementId: o
  });
  return /* @__PURE__ */m("div", {
    ref: i,
    className: p.positionedPopover,
    id: o,
    style: _objectSpread(_objectSpread({}, n), {}, {
      zIndex: s
    }),
    children: e
  });
};

export { f as HyperlinkPosition };